<h4 class="mb-3 display-4">{{ carrier_label | translate }}</h4>

<hr class="mb-3" />

<div class="row row-cols-2 row-cols-md-4 g-3">
  @for (i of sortCarrier(device_items); track i) {
    <div class="col">
      <div
        as-button
        class="card overflow-auto h-100"
        [ngClass]="{ 'p-2': getCarrierAdmin(i) }"
        [class.active-card]="isCarrierSelected(i)"
        [class.elevate]="!isCarrierSelected(i)"
        [attr.aria-label]="getCarrierName(i)"
        (click)="selectCarrier(i)"
      >
        <div class="card-body p-4 d-flex justify-content-center">
          <img class="carrier-img img-fluid" [src]="getCarrierImage(i)" [alt]="getCarrierName(i)" />
        </div>
        @if (getCarrierAdmin(i)) {
          <ts-admin-override-badge class="position-absolute bottom-0 end-0" />
        }
      </div>
    </div>
  }
</div>
